import domready from 'domready'
import PhotoSwipeController from './controllers/photoswipe-controller'

export default function initPhotoSwipe () {
  domready(() => {
    const element = document.querySelector('.pswp')
    if (element) {
      // eslint-disable-next-line no-new
      new PhotoSwipeController(element)
    }
  })
}
